import gql from "graphql-tag"

export default gql`
  fragment fullInternalUser on InternalUser {
    uuid
    email
    featureFlags
    fullName
    isEnabled
    locationDescription
    profileImageUrl
    shortDescription
  }
`
